<template>
  <div class="header-notifications-bubble-top">
    <span>Notifications</span>
    <button @click="$emit('clearNotification')" class="header-notifications-clear link"><span>Clear notifications</span></button>
  </div>
</template>

<script>
export default {
name: "NotificationTooltipHeader",
}
</script>

<style scoped>

</style>